import React from 'react';

// Day Events Modal Component (renamed from EventDetailsModal)
const DayEventsModal = ({ date, dayEvents, onClose, onViewEventDetails, onAddTask }) => { // Added onAddTask prop
  if (!date || !dayEvents || dayEvents.length === 0) return null;

  const eventTypeColors = {
    meeting: { bg: '#E0F2FE', text: '#1D4ED8', border: '#3B82F6' },
    task: { bg: '#FFFBEB', text: '#B45309', border: '#F59E0B' },
    deadline: { bg: '#FEF2F2', text: '#B91C1C', border: '#EF4444' },
    default: { bg: '#F3F4F6', text: '#4B5563', border: '#9CA3AF' },
  };

  return (
    <div className="fixed inset-0 bg-[#111827] bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-[#FFFFFF] p-6 rounded-lg shadow-xl max-w-lg w-full relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>

        <h3 className="text-2xl font-bold text-gray-800 mb-4">Events for {date}</h3>

        {dayEvents.length > 0 ? (
          <div className="space-y-4 max-h-80 overflow-y-auto custom-scrollbar pr-2">
            {dayEvents.map(event => {
              const colors = eventTypeColors[event.type] || eventTypeColors.default;
              return (
                <div key={event.id} className={`p-4 rounded-lg border-l-4 ${colors.bg} ${colors.border}`}>
                  <h4 className={`text-lg font-semibold ${colors.text} mb-1`}>{event.title}</h4>
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Type:</span> {event.type.charAt(0).toUpperCase() + event.type.slice(1)}
                  </p>
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Project:</span> {event.project}
                  </p>
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Assigned To:</span> {event.assignedTo}
                  </p>
                  {event.status && (
                    <p className="text-sm text-gray-700">
                      <span className="font-medium">Status:</span> {event.status.charAt(0).toUpperCase() + event.status.slice(1)}
                    </p>
                  )}
                  <div className="mt-3 text-right">
                    <button
                      onClick={() => onViewEventDetails(event.id, event.type_id)}
                      className="px-4 py-2 rounded-lg bg-purple-600 text-white font-semibold hover:bg-purple-700 transition-colors shadow-md text-sm"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-gray-600">No events for this day.</p>
        )}

        <div className="flex justify-end mt-6 space-x-3"> 
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors font-medium"
          >
            Close Day Events
          </button>
          <button
            onClick={() => onAddTask(date)} 
            className="px-5 py-2 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 transition-colors shadow-md"
          >
            + Add New Task
          </button>
        </div>
        
      </div>
      
    </div>
  );
};

export default DayEventsModal; 